import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Image, Text } from '@chatterbug/aaron'

import { t } from 'src/lib/i18n-react'
import cross from 'src/ui/assets/icons/close.svg'

export const PopoutDefaultHeader = ({ title, onClick }) => {
  return (
    <Flex
      alignItems="center"
      justifyContent={title ? 'space-between' : 'flex-end'}
      pl="2x"
    >
      <Text variant="text.tinyTitle">{title}</Text>
      <Flex
        aria-label={t('Close')}
        as="button"
        borderRadius="0,5x"
        onClick={onClick}
        borderWidth="0"
        bg="transparent"
        width="44px"
        justifyContent="center"
        alignItems="center"
        height="44px"
      >
        <Image alt="" src={cross} />
      </Flex>
    </Flex>
  )
}

PopoutDefaultHeader.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
}

export const PopoutMenu = ({
  show = false,
  onClose,
  PopoutHeader,
  popoutWidth,
  PopoutButton,
  PopoutBody,
  mobileFullscreen = true,
}) => {
  const popoutElement = useRef()

  useEffect(() => {
    function closePopout(event) {
      const conditionOne =
        event.type === 'keydown' && event.key === 'Escape' && show
      //We only want to close and apply the filters the click target is NOT
      //the filter
      const conditionTwo =
        event.type === 'click' &&
        !popoutElement.current?.contains(event.target) &&
        show

      if (conditionOne || conditionTwo) {
        onClose()
      }
    }

    document.addEventListener('click', closePopout)
    document.addEventListener('keydown', closePopout)
    return () => {
      document.removeEventListener('click', closePopout)
      document.removeEventListener('keydown', closePopout)
    }
  }, [show, onClose])

  return (
    <Box position={{ _: 'static', tablet: 'relative' }} display="inline-block">
      {PopoutButton}
      {show && (
        <Flex
          display={show ? 'flex' : 'none'}
          position="absolute"
          zIndex="2"
          width={{ _: '100%', tablet: popoutWidth || 'auto' }}
          minWidth="200px"
          left={{ _: '0', tablet: 'auto' }}
          justifyContent="center"
          alignItems="center"
          top={mobileFullscreen ? { _: '0', tablet: 'auto' } : 'auto'}
          backgroundColor={
            mobileFullscreen
              ? { _: 'rgba(0, 0, 0, 0.8)', tablet: 'transparent' }
              : 'transparent'
          }
          paddingX={mobileFullscreen ? 0 : { _: '2x', tablet: 0 }}
          padding={mobileFullscreen ? { _: '1x', tablet: 0 } : 0}
          marginTop={mobileFullscreen ? { _: 0, tablet: '0,5x' } : '0,5x'}
          height={mobileFullscreen ? { _: '100%', tablet: 'auto' } : 'auto'}
        >
          <Flex
            ref={popoutElement}
            bg="white100"
            maxHeight="90%"
            borderRadius="1x"
            boxShadow="raised"
            flexDirection="column"
            flex="1"
            overflow="hidden"
            pt={mobileFullscreen ? 0 : { _: '2x', tablet: 0 }}
            mx={{ _: '2x', tablet: 0 }}
          >
            {PopoutHeader}
            {PopoutBody}
          </Flex>
        </Flex>
      )}
    </Box>
  )
}

PopoutMenu.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  popoutWidth: PropTypes.string,
  PopoutButton: PropTypes.element,
  PopoutHeader: PropTypes.element,
  PopoutBody: PropTypes.element.isRequired,
  mobileFullscreen: PropTypes.bool,
}
